import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA-bPQAqAqj_2XR7jVphG1asgMeiqe9Kss",
  authDomain: "right-cash-eb558.firebaseapp.com",
  databaseURL: "https://right-cash-eb558-default-rtdb.firebaseio.com",
  projectId: "right-cash-eb558",
  storageBucket: "right-cash-eb558.firebasestorage.app",
  messagingSenderId: "517039116462",
  appId: "1:517039116462:web:5c386dab8f44af7dfcdd3f",
  measurementId: "G-L17K2FF9ZT",
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, getDocs };
